<template>
  <mdb-container class="gp-has-header"
                 v-if="loggedIn && details && settings.features && settings.features.systemBilling ">
    <mdb-card v-if="payWallMessage" class="mb-4">
      <mdb-card-header class="warning-color text-white">
        <h4>Subscription Needed</h4>
      </mdb-card-header>
      <mdb-card-body class="text-left">
        <div>
          <div>{{ payWallText }}</div>
          <mdb-btn v-if="payWallReturnUrl" @click="$router.push(payWallReturnUrl)" icon="arrow-left">Return to
            {{ payWallGroupName }}
          </mdb-btn>
        </div>
      </mdb-card-body>
    </mdb-card>

    <div v-if="!payWallMessage && payWallReturnUrl">
      <mdb-btn v-if="payWallReturnUrl" @click="$router.push(payWallReturnUrl)" icon="arrow-left">Return to
        {{ payWallGroupName }}
      </mdb-btn>
    </div>

    <div class="mb-4" v-if="details.introText" v-html="details.introText">

    </div>


    <div>
      <mdb-card class="mb-4">
        <mdb-card-header>
          <h4>Billing Plan</h4>
        </mdb-card-header>
        <mdb-card-body class="text-left">
          <div v-if="details.currentPlanName">
            <h5>Current Plan: {{ details.currentPlanName }}</h5>
            <div v-if="!details.pendingChange && details.mayChangePlan">
              <mdb-btn size="sm" rounded icon="pencil" @click="$router.push('/user/plan-shopper')">Change</mdb-btn>
              <mdb-btn size="sm" color="danger" rounded icon="times-circle" @click="cancelModal=true">Cancel
              </mdb-btn>
            </div>
            <div v-if="!details.mayChangePlan && details.currentPlanName && !details.pendingChange" class="small text-info">
              {{ settings.siteName }} has assigned this plan to you and it cannot be changed at this time.
            </div>
          </div>
          <div v-if="!details.currentPlanName && !details.pendingChange">
            <h5>You do not currently have a billing plan.</h5>
          </div>

          <div v-if="!details.currentPlanName && !details.pendingChange">
            <mdb-btn icon="pencil" @click="$router.push('/user/plan-shopper')">Select a Plan</mdb-btn>
          </div>

          <div v-if="details.paidThrough" class="pt-2">
            <p>You are paid through {{ details.paidThrough }}</p>
          </div>

          <mdb-card v-if="details.pendingChange">
            <mdb-card-body v-if="details.pendingChange.changeType=='UPGRADE'">
              Upgrading to <b>{{details.pendingChange.planName}}</b>.
              <span v-if="details.pendingChange.upgradeAmount > 0">Your credit card will be charged the prorated upgrade cost of <b>{{details.pendingChange.currencySymbol}}{{details.pendingChange.upgradeAmount | formatNumber}}</b></span>
              <div class="text-danger" v-if="!details.hasPaymentInfo">
                Please add a credit card to complete this upgrade.
              </div>
              <div>
                <mdb-btn  v-if="details.hasPaymentInfo" size="sm" color="success" icon="check" @click="completeUpgrade">Complete Upgrade</mdb-btn>
                <mdb-btn size="sm" color="danger" icon="times-circle" @click="cancelPendingChange">Cancel Upgrade</mdb-btn>
              </div>
            </mdb-card-body>

            <mdb-card-body v-if="details.pendingChange.changeType=='ADD_PLAN'">
              You are adding a subscription to <b>{{details.pendingChange.planName}}</b>.
              <span v-if="details.pendingChange.upgradeAmount > 0">Your credit card will be charged <b>{{details.pendingChange.currencySymbol}}{{details.pendingChange.upgradeAmount | formatNumber}}</b>.</span>
              <div class="text-danger" v-if="!details.hasPaymentInfo">
                Please add a credit card to continue.
              </div>
              <div>
                <mdb-btn v-if="details.hasPaymentInfo" size="sm" color="success" icon="check" @click="completeUpgrade">Complete Subscription</mdb-btn>
                <mdb-btn size="sm" color="danger" icon="times-circle" @click="cancelPendingChange">Cancel</mdb-btn>
              </div>
            </mdb-card-body>



            <mdb-card-body v-if="details.pendingChange.changeType=='DOWNGRADE'">
              You have elected to downgrade your plan to {{details.pendingChange.planName}} after the current period ends.
                <mdb-btn size="sm" color="success" icon="times-circle" @click="cancelPendingChange">Cancel Downgrade</mdb-btn>
            </mdb-card-body>

            <mdb-card-body v-if="details.pendingChange.changeType=='CANCELLATION'">
              You have elected to cancel your subscription after the current period ends.
              <mdb-btn size="sm" color="success" icon="times-circle" @click="cancelPendingChange">Keep Subscription</mdb-btn>
            </mdb-card-body>

            <mdb-card-body v-if="details.pendingChange.changeType=='CONVERT_FREE_TRIAL'">
              You have elected to convert your free trial to {{details.pendingChange.planName}}. This change will not take effect until your trial ends.
              <div class="text-danger" v-if="!details.hasPaymentInfo && details.pendingChange.newPlanAmount > 0">
                Please add a credit card to avoid interruption in your subscription. You will not be charged until your free trial ends.
              </div>
              <mdb-btn size="sm" color="danger" icon="times-circle" @click="cancelPendingChange">Cancel</mdb-btn>
            </mdb-card-body>

            <mdb-card-body v-if="details.pendingChange.changeType=='TERM_CHANGE'">
              You have elected to change your plan to {{details.pendingChange.planName}} after the current period ends.
              <mdb-btn size="sm" color="danger" icon="times-circle" @click="cancelPendingChange">Cancel Change</mdb-btn>
            </mdb-card-body>


          </mdb-card>

          <mdb-card v-if="details.hasBalance">
            <mdb-card-header>
              <h5>Current Balance Summary</h5>
            </mdb-card-header>
            <mdb-card-body>
              <mdbTbl striped responsive>
                <mdbTblBody class="text-right">
                  <tr>
                    <td><b>Base Membership:</b></td>
                    <td>{{ details.balanceSymbol }} {{ details.baseCharge | formatNumber }}</td>
                  </tr>
                  <tr v-if="details.additionalGroupsCharge != 0">
                    <td><b>Additional Premium Membership ({{ details.totalGroups - 1 }}):</b></td>
                    <td> {{ details.balanceSymbol }} {{ details.additionalGroupsCharge | formatNumber }}</td>
                  </tr>
                  <tr v-if="details.ownerPaysCharge != 0">
                    <td><b>"Owner Pays" Group(s):</b></td>
                    <td> {{ details.balanceSymbol }} {{ details.ownerPaysCharge | formatNumber }}</td>
                  </tr>
                  <tr v-if="details.discountApplied != 0">
                    <td><b>Discount Applied:</b></td>
                    <td> {{ details.balanceSymbol }} {{ details.discountApplied | formatNumber }}</td>
                  </tr>
                  <tr>
                    <td><h5>Balance Due:</h5></td>
                    <td><h5>{{ details.balanceSymbol }} {{ details.balance | formatNumber }}
                      ({{ details.balanceCurrency }})</h5></td>
                  </tr>
                </mdbTblBody>
              </mdbTbl>

              <div v-if="details.balance > 0 && details.hasPaymentInfo" class="text-center">
                <mdb-btn icon="credit-card" color="success" @click="payNow">Pay Now</mdb-btn>
              </div>
            </mdb-card-body>
          </mdb-card>
        </mdb-card-body>
      </mdb-card>

      <mdb-card class="mb-4" v-if="details && details.checkoutKey">
        <mdb-card-header>
          <h4>Credit Card</h4>
        </mdb-card-header>
        <mdb-card-body class="text-left">
          <div v-if="details.hasPaymentInfo">
            Current Payment Method: {{ details.type }} ending in {{ details.ccLast4 }}, Expires {{ details.ccExpire }}
            <br/>
            <mdb-btn @click="showCardArea=true" icon="credit-card">Change Card</mdb-btn>
            <mdb-btn @click="removeCard" color="danger" icon="trash">Remove Card</mdb-btn>
          </div>
          <div v-if="!details.hasPaymentInfo">
            <mdb-btn @click="showCardArea=true" icon="credit-card">Add Card</mdb-btn>
            <div v-if="details.inFreeTrial" class="text-info">
              You will not be charged until your free trial period ends.
            </div>
          </div>
          <div v-if="showCardArea">
            <card :class='{ complete }'
                  :stripe='details.checkoutKey'
                  @change='complete = $event.complete'
                  class='stripe-card'
            />
            <mdb-input label="Name" placeholder="Name as it appears on Card" type="text" v-model="ccName"/>
            <mdb-btn :disabled="!complete || !ccName " @click="pay" icon="check-circle">Submit Card</mdb-btn>
          </div>
          <div class="text-info small">
            {{ settings.siteName }} does not store your credit card information on its servers. Instead, your payment
            information is collected
            by <a href="https://stripe.com" target="_blank">Stripe</a>, a global payment processor with exceptional
            security protections in place.
          </div>
          <div v-if="details.hasBalance && !details.hasPaymentInfo">You may remove your credit card
            at any time to <span class="text-danger">cancel</span> your subscription.
          </div>
        </mdb-card-body>
      </mdb-card>

      <mdb-card class="mb-4">
        <mdb-card-header>
          <h4>Transaction History</h4>
        </mdb-card-header>
        <mdb-card-body class="text-left">
          <mdb-tbl responsive striped>
            <mdb-tbl-head class="secondary-color">
              <tr>
                <th>Date</th>
                <th>Description</th>
                <th>Amount</th>
                <th>Confirmation</th>
              </tr>
            </mdb-tbl-head>
            <mdb-tbl-body>
              <tr :key="i" v-for="(t,i) in details.transactions">
                <td>{{ t.date }}</td>
                <td>{{ t.description }}</td>
                <td class="text-right">{{ t.amount }}</td>
                <td>{{ t.confirmationCode }}</td>
              </tr>
            </mdb-tbl-body>
          </mdb-tbl>
        </mdb-card-body>
      </mdb-card>

    </div>

    <yes-no-modal @no="cancelModal = false"
                  @yes="cancelPlan"
                  question="Are you sure you wish to cancel your current plan?"
                  v-if="cancelModal"/>

  </mdb-container>

</template>
<script>
import api from '../../services/groupsPlaceApi.js'
import {Card, createToken} from 'vue-stripe-elements-plus'
import YesNoModal from "../common/YesNoModal";
import {
  mdbBtn,
  mdbCard,
  mdbCardBody,
  mdbCardHeader,
  mdbContainer,
  mdbIcon,
  mdbInput,
  mdbTbl,
  mdbTblBody,
  mdbTblHead
} from 'mdbvue';

export default {
  name: "user-billing",
  display: "User Billing",
  order: 1,
  components: {
    mdbContainer,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbBtn,
    mdbIcon,
    mdbTbl,
    mdbTblHead,
    mdbTblBody,
    mdbInput,
    Card,
    YesNoModal
  },
  filters: {
    formatNumber: function (val) {
      return val.toLocaleString(undefined, {minimumFractionDigits: 2})
    }
  },
  computed: {
    loggedIn() {
      return this.$store.state.loggedIn
    },
    settings() {
      return this.$store.state.settings
    },
    userDetails() {
      return this.$store.state.userDetails
    },
    toDos() {
      return this.$store.state.toDos
    },
  },
  data() {
    return {
      details: null,
      complete: false,
      ccName: null,
      showCardArea: false,
      siteName: "",
      newPlan: null,
      payWallMessage: false,
      payWallText: "",
      payWallGroupName: null,
      payWallReturnUrl: null,
      previewedRemove: false,
      previewDetails: null,
      cancelModal: false
    }
  },
  mounted() {
    document.title = "Billing"
    if (this.$route.query.source == "paywall-join") {
      this.payWallMessage = true
      this.payWallText = `In order to join ${this.$route.query.group}, you need a paid subscription on
            ${this.settings.siteName}. Please ensure your desired plan is correct and there is a valid payment method on file for your account.`
      if (this.$route.query.group) this.payWallGroupName = decodeURI(this.$route.query.group)
      if (this.$route.query.return) this.payWallReturnUrl = decodeURI(this.$route.query.return)
    }
    if (this.$route.query.source == "paywall-rsvp") {
      this.payWallMessage = true
      this.payWallText = this.$route.query.message
      if (this.$route.query.return) this.payWallReturnUrl = decodeURI(this.$route.query.return)
      if (this.$route.query.group) this.payWallGroupName = decodeURI(this.$route.query.group)
    }
    this.loadDetails()
  },
  methods: {
    cancelRemoveCharges() {
      this.previewedRemove = false
      this.previewDetails = null
    },
    previewRemoveCharges() {
      this.$store.dispatch("setExecuting", true)
      api.get("/user/previewRemoveCharges").then(
        (results) => {
          this.previewDetails = results.data
          this.previewedRemove = true
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    confirmRemoveCharges() {
      this.$store.dispatch("setExecuting", true)
      api.get("/user/confirmRemoveCharges").then(
        (results) => {
          this.previewDetails = results.data
          if (results.data.success) {
            this.previewedRemove = false
            this.details.balance = 0
            this.details.hasBalance = false
            this.loadDetails()
          }

        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })

    },
    loadDetails() {
      this.$store.dispatch("setExecuting", true)
      api.get("/user/billing").then(
        (results) => {
          this.details = results.data
        },
        (error) => {
          if (error.response.status == 404) this.$router.push("/404")
          else this.$notify.error({message: error.response.data, timeOut: 20000})

        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    pay() {
      // createToken returns a Promise which resolves in a result object with
      // either a token or an error key.
      // See https://stripe.com/docs/api#tokens for the token object.
      // See https://stripe.com/docs/api#errors for the error object.
      // More general https://stripe.com/docs/stripe.js#stripe-create-token.
      createToken({name: this.ccName, currency: "usd"}).then(data =>
                                                               this.submitPayment(data.token)
      )
    },
    cancelPlan() {
      this.cancelModal = false
      this.$store.dispatch("setExecuting", true);
      let payload = {id: this.details.subscriptionId}
      api.post("/user/cancelSubscription/", payload).then(
        (results) => {
          this.loadDetails()
        },
        (error) => {
          this.$notify.error({message: "Could not remove pending upgrade. " + error.response.data, timeOut: 20000})
          this.$store.dispatch("setExecuting", false)
        })

    },
    cancelPendingChange() {
      this.$store.dispatch("setExecuting", true);
      let payload = {id: this.details.pendingChange.id}
      api.post("/user/cancelPendingChange/", payload).then(
        (results) => {
          this.loadDetails()
        },
        (error) => {
          this.$notify.error({message: "Could not remove pending upgrade. " + error.response.data, timeOut: 20000})
          this.$store.dispatch("setExecuting", false)
        })

    },
    completeUpgrade() {
      this.$store.dispatch("setExecuting", true);
      let payload = {id: this.details.pendingChange.id}
      api.post("/user/completeUpgrade/", payload).then(
        (results) => {
          this.loadDetails()
        },
        (error) => {
          this.$notify.error({message: "Could not complete pending upgrade. " + error.response.data, timeOut: 20000})
          this.$store.dispatch("setExecuting", false)
        })

    },
    submitPayment(token) {
      this.$store.dispatch("setExecuting", true);
      let payload = {token: token.id, name: this.ccName}
      api.post("/user/paymentData/", payload).then(
        (results) => {
          this.userDetails.billingSuspension = false
          this.details.ccLast4 = results.data.ccLast4
          this.details.ccExpire = results.data.ccExpire
          this.details.type = results.data.type
          this.details.hasPaymentInfo = true
          this.details.paymentMethodId = results.data.paymentMethodId
          this.showCardArea = false
          if (!results.data.success) {
            this.$notify.error({message: results.data.message, timeOut: 10000})
          } else {
            if (this.details.hasBalance && results.data.balance == 0) {
              this.resetBilling()
              this.$notify.success({message: "Thank you for your payment!", timeOut: 5000})
            } else this.$notify.success({message: "Credit Card Submitted", timeOut: 5000})
          }
        },
        (error) => {
          this.$notify.error({message: "Could not save card. " + error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    },
    payNow() {
      this.$store.dispatch("setExecuting", true);
      api.post("/user/payNow/", {paymentMethod: this.details.paymentMethodId, charge: this.details.chargeId}).then(
        (results) => {
          this.resetBilling()
        },
        (error) => {
          this.$notify.error({message: error.response.data, timeOut: 8000})
          this.$store.dispatch("setExecuting", false)
        })
    },
    resetBilling() {
      this.loadDetails()
      this.payWallMessage = ""
      for (let i = 0; i < this.toDos.length; i++) {
        let spliceLoc = -1
        if (this.toDos[i].functionName == "balanceDue") {
          spliceLoc = i
        }
        if (spliceLoc >= 0) this.toDos.splice(spliceLoc, 1)
      }
    },
    removeCard() {
      this.$store.dispatch("setExecuting", true);
      api.post("/user/removeCreditCard/", {paymentMethod: this.details.paymentMethodId}).then(
        (results) => {
          this.details.hasPaymentInfo = false
          if (results.data.billingSuspension) this.userDetails.billingSuspension = true
          this.$notify.success({message: "Credit Card Removed", timeOut: 5000})
        },
        (error) => {
          this.$notify.error({message: "Could not delete payment method. " + error.response.data, timeOut: 20000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }

};
</script>

<style lang='scss'>
.stripe-card {
  width: 300px;
  border: 1px solid grey;
}

.stripe-card.complete {
  border-color: green;
}
</style>
